export default [
    {
        "href": "/architecture-constructions/realisations/extruded-lighting-insert-profile",
        "thumbnail": require("../assets/images/orly-sud-photo.jpg"),
        "titles": {
            "fr": [
                "Profils extrudés d'insert d'éclairage"
            ],
            "en": [
                "Extruded lighting insert profiles"
            ]
        },
        "class": "col-xs-8 col-lg-8 col-sm-8"
    },
    {
        "href": "/architecture-constructions/realisations/extruded-profile-glazed-facade-upright",
        "thumbnail": require("../assets/images/cnfpt-lille.jpg"),
        "titles": {
            "fr": [
                "Profil extrudé montant de façade vitrée"
            ],
            "en": [
                "Extruded profile glazed facade upright"
            ]
        },
        "class": "col-xs-8 col-lg-8 col-sm-8"
    },
    {
        "href": "/architecture-constructions/realisations/special-handrail-profiles",
        "thumbnail": require("../assets/images/ciup-ret.jpg"),
        "titles": {
            "fr": [
                "Profils spécial de main courante"
            ],
            "en": [
                "Special handrail profiles"
            ]
        },
        "class": "col-xs-8 col-lg-8 col-sm-8"
    },
    {
        "href": "/architecture-constructions/realisations/non-slip-steel-stair-nosing",
        "thumbnail": require("../assets/images/industry-architecture.jpg"),
        "titles": {
            "fr": [
                "Nez de marche antidérapante en acier inoxydable étiré à froid"
            ],
            "en": [
                "Non-slip stair nosing made of cold-drawn stainless steel"
            ]
        },
        "class": "col-xs-8 col-lg-8 col-sm-8"
    },
    {
        "href": "/architecture-constructions/realisations/extruded-structural-profiles",
        "thumbnail": require("../assets/images/orchard1.jpg"),
        "titles": {
            "fr": [
                "Profils extrudés de structure"
            ],
            "en": [
                "Extruded structural profiles"
            ]
        },
        "class": "col-xs-8 col-lg-8 col-sm-8"
    }
]